import { render } from "./ModuleNotInTariffModal.vue?vue&type=template&id=a04eddd6"
import script from "./ModuleNotInTariffModal.vue?vue&type=script&lang=js"
export * from "./ModuleNotInTariffModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__